export type AppdomainId =
    | 17
    | 18
    | 35
    | 36
    | 37
    | 38
    | 39
    | 40
    | 41
    | 43
    | 44
    | 45
    | 46
    | 51
    | 60
    | 61
    | 62
    | 63
    | 66
    | 67
    | 70
    | 71;

export type Appdomain =
    | 'de'
    | 'fr'
    | 'nl'
    | 'benl'
    | 'befr'
    | 'com'
    | 'at'
    | 'chde'
    | 'chfr'
    | 'uk'
    | 'it'
    | 'pl'
    | 'es'
    | 'cz'
    | 'se'
    | 'dk'
    | 'fi'
    | 'no'
    | 'lt'
    | 'sk'
    | 'pt'
    | 'ro';

export const APPDOMAIN_IDS: { [key in Appdomain]: AppdomainId } = {
    de: 17,
    fr: 18,
    nl: 35,
    benl: 36,
    befr: 37,
    com: 38,
    at: 39,
    chde: 40,
    chfr: 41,
    uk: 43,
    it: 44,
    pl: 45,
    es: 46,
    cz: 51,
    se: 60,
    dk: 61,
    fi: 62,
    no: 63,
    lt: 66,
    sk: 67,
    pt: 70,
    ro: 71,
};

export const APPDOMAIN_NAMES: { [key in AppdomainId]: Appdomain } = {
    17: 'de',
    18: 'fr',
    35: 'nl',
    36: 'benl',
    37: 'befr',
    38: 'com',
    39: 'at',
    40: 'chde',
    41: 'chfr',
    43: 'uk',
    44: 'it',
    45: 'pl',
    46: 'es',
    51: 'cz',
    60: 'se',
    61: 'dk',
    62: 'fi',
    63: 'no',
    66: 'lt',
    67: 'sk',
    70: 'pt',
    71: 'ro',
};

export const LOCALE_PER_APPDOMAINID: { [key in AppdomainId]: string } = {
    17: 'de_DE',
    18: 'fr_FR',
    35: 'nl_NL',
    36: 'nl_BE',
    37: 'fr_BE',
    38: 'en_FI',
    39: 'de_AT',
    40: 'de_CH',
    41: 'fr_CH',
    43: 'en_GB',
    44: 'it_IT',
    45: 'pl_PL',
    46: 'es_ES',
    51: 'cs_CZ',
    60: 'sv_SE',
    61: 'da_DK',
    62: 'fi_FI',
    63: 'no_NO',
    66: 'lt_LT',
    67: 'sk_SK',
    70: 'pt_PT',
    71: 'ro_RO',
};

export type CountryCodeMap<T> = {
    AT: T;
    BE: T;
    CH: T;
    DE: T;
    FR: T;
    IT: T;
    NL: T;
    PL: T;
    GB: T;
    FI: T;
    SE: T;
    DK: T;
    ES: T;
    CZ: T;
    NO: T;
    LT: T;
    SK: T;
    PT: T;
    RO: T;
};

export type CountryCode = keyof CountryCodeMap<void>;
